import React from 'react';
import { CallDetails } from '../../models/dto/call';

export default function TethrCallLink(props: { call: CallDetails; tethrUrl: string | nundefined; hasLinkText: string; noLinkText: string; }) {
	if (props.call.statusId === 'Complete' && props.tethrUrl && props.call.tethrCallId) {
		const link = `${props.tethrUrl}${props.tethrUrl.endsWith('/') ? '' : '/'}calls/${props.call.tethrCallId}`;
		return <div><a href={link} rel="noopener noreferrer">{props.hasLinkText}</a></div>;
	} else {
		return <div>{props.noLinkText}</div>
	}
}
